// Iter-276.G (Top-20 #20) — AffiliateBadge extracted from
// PartnerRateTable.jsx as part of the LoC refactor. FTC-grade per-link
// disclosure rendered beside every functional Apply button. Tiny size
// keeps it from competing with the CTA; native browser `title` tooltip
// on hover + `aria-label` for screen readers.
//
// Iter-185.X — Routes to /disclosure (the dedicated FTC-aligned
// affiliate-disclosure page) instead of /about. Matches the "single
// click from any commercial CTA to the disclosure page" requirement
// most major affiliate networks (Impact, CJ, Bankrate-style enterprise
// programs) audit for during publisher approval.

import React from "react";
import { Info } from "lucide-react";

export default function AffiliateBadge({ slug }) {
  const tooltip =
    "Affiliate link: CarSavr may earn a commission if you apply and qualify with this lender. Compensation does not affect our editorial rankings.";
  return (
    <a
      href="/disclosure"
      target="_blank"
      rel="noopener noreferrer"
      title={tooltip}
      aria-label={tooltip}
      data-testid={`rate-affiliate-badge-${slug}`}
      className="inline-flex items-center justify-center gap-1 text-[9px] font-bold uppercase tracking-[0.14em] text-slate-500 hover:text-slate-700 transition-colors"
    >
      <Info className="w-2.5 h-2.5" />
      Affiliate offer
    </a>
  );
}
